<template>
  <base-configurable-product>
    <div class="my10 price-wrapper">
      <p class="fs-medium-small cl-light-gray m0 text-nowrap">
        {{ getAllAttributeList('retail_price') }} {{ getCurrentProduct.retail_price | price(storeView) }}
      </p>
      <SpecialOfferLabel v-if="isSpecialOffer">
        {{ getLabelFor('info_label', getCurrentProduct.info_label) }}
      </SpecialOfferLabel>
    </div>
    <SubscriptionRent v-if="isSubscriptionAvaliable" class="mb15" @click.native="updatePeriod()" :first-available="firstAvailableSection" />
    <SingleRent v-if="!isLogged || !isEnoughPoints || !isSubscriptionAvaliable" class="mb15" @click.native="updatePeriod()" :first-available="firstAvailableSection" :scroll-to-try-on="scrollToTryOn" />
    <div id="try-on" />
    <TryOn v-if="isTryOn && !isSubscriptionAvaliable" class="mb15" @click.native="updatePeriod()" :first-available="firstAvailableSection" />

    <template #options>
      <product-custom-options
        v-if="getCurrentProduct.custom_options && getCurrentProduct.custom_options.length > 0"
        :product="getCurrentProduct"
      />
    </template>
  </base-configurable-product>
</template>

<script>
import { mapGetters } from 'vuex'
import { ProductMixin } from 'theme/components/core/blocks/Product-v2/ProductMixin.ts'
import BaseConfigurableProduct from './BaseConfigurableProduct.vue'
import SingleRent from './Rent/SingleRent.vue'
import SubscriptionRent from './Rent/SubscriptionRent.vue'
import TryOn from './Rent/TryOn.vue'
import SpecialOfferLabel from 'theme/components/core/blocks/Product-v2/components/SpecialOfferLabel'
import { isServer } from '@vue-storefront/core/helpers'

export default {
  name: 'RentConfigurableProduct',
  components: {
    BaseConfigurableProduct,
    SingleRent,
    SubscriptionRent,
    TryOn,
    SpecialOfferLabel
  },
  mixins: [ProductMixin],
  computed: {
    ...mapGetters({
      getPeriods: 'calendar/getPeriods',
      getUserBalance: 'user/getBalance',
      isLogged: 'user/isLoggedIn'
    }),
    isSubscriptionAvaliable () {
      return this.getCurrentProduct.subscription_points
    },
    isEnoughPoints () {
      return this.getUserBalance >= 1
    },
    isTryOn () {
      if (isServer) return true
      let dayPeriod = this.getPeriods && this.getPeriods.find(period => period === 2)
      return !!dayPeriod
    },
    firstAvailableSection () {
      if (this.isSubscriptionAvaliable) {
        return 'With membership'
      } else {
        return 'One-time rental'
      }
    },
    isFinalPrice () {
      const sirentalPrice = this.getCurrentProduct.sirental_price
      if (!sirentalPrice) return false
      return !!Number(sirentalPrice.every(price => price.final_price))
    },
    isInfoLabel () {
      return this.getCurrentProduct.info_label
    },
    isSpecialOffer () {
      return this.isInfoLabel && this.isFinalPrice
    }
  },
  async mounted () {
    this.setAvaliableSourceCodes()
  },
  methods: {
    updatePeriod () {
      this.$store.dispatch('calendar/updateCalendarData')
    },
    setAvaliableSourceCodes () {
      if (this.getCurrentProduct.stock && this.getCurrentProduct.stock.source_codes && this.getCurrentProduct.stock.source_codes.length) {
        this.$store.commit('calendar/setAvailableDeliveries', this.getCurrentProduct.stock.source_codes)
      } else {
        this.$store.commit('calendar/setAvailableDeliveries', [])
      }
      this.$store.dispatch('calendar/loadCalendarData', { sku: this.getCurrentProduct.sku })
    },
    async scrollToTryOn () {
      await document.getElementsByClassName('rent-header-try-on')[0].click();
      const tryOnWrapper = document.getElementById('try-on');
      tryOnWrapper.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
</script>

<style lang="scss" scoped>
.price-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

#try-on {
  height: 200px;
  margin-top: -200px;
}
</style>
